module.exports = __webpack_public_path__ + "media/images/children-0c6e07b31461628d30c54439624e12ed.jpg";